import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import { AnimatedItem } from '../../components/animation/AnimatedItem';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import Spinner from '../../components/common/Spinner';
import { Button, Flexed, PageTitle } from '../../styles/GlobalComponents';
import { FlexBetween, HubLengthMessage } from '../../styles/stylesStyled';
import { InvoiceHeader, Invoices } from '../Accounting/AccountingStyled';
import {
  getWebinars,
  purchaseWebinarTicket
} from '../../slices/webinars-slice';
import SoldTickets from './SoldTickets';
import { color } from '../../styles/GlobalStyles';
import { P3 } from '../../styles/FontStyles';
import { AnimatedTab, SelectNetwork } from '../../components';
import { SelectToken } from '../../components/common/SelectNetwork/SelectToken';
import CreateTicket from './CreateTicket';
import Success from './Success';
import { calculateVatPrice } from '../../helpers/helperFunctions';

export enum WebinarsSteps {
  PURCHASE = 1,
  SUCCESS
}

export const Webinars = () => {
  const [selectedNetwork, setSelectedNetwork] = useState<any>('');
  const [selectedToken, setSelectedToken] = useState<any>();
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [isPurchaseTicketModalOpen, setPurchaseTicketModalOpen] =
    useState(false);

  const [selectedWebinar, setSelectedWebinar] = useState<any>(null);

  const [step, setStep] = useState(WebinarsSteps.PURCHASE);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWebinars());
  }, [dispatch]);

  const { loading, webinars } = useAppSelector((state) => state.webinars);

  if (loading) {
    return <Spinner fullScreen transparent />;
  }

  return (
    <AnimatedDashboard zoom>
      <Flexed between center>
        <PageTitle>All Webinars</PageTitle>
      </Flexed>

      <InvoiceHeader>
        <div style={{ width: '14.28%' }}>Name</div>
        <div style={{ width: '14.28%' }}>Date Start</div>
        <div style={{ width: '12%' }}>Timezone</div>
        <div style={{ width: '12%' }}>Ticket Price</div>
        <div style={{ width: '12%' }}>Available Tickets</div>
        <div style={{ width: '14.28%' }}>Description</div>
        <div style={{ width: '14.28%' }}>User</div>
        <div style={{ width: '14.28%' }}>Sold Tickets</div>
        <div style={{ width: '14.28%' }}>Action</div>
      </InvoiceHeader>

      {webinars?.length === 0 ? (
        <HubLengthMessage style={{ cursor: 'pointer' }}>
          No Tickets
        </HubLengthMessage>
      ) : (
        webinars?.map((inv: any, i: number) => {
          const isExpired = new Date(inv?.dateStart) < new Date();
          return (
            <AnimatedItem key={i} index={i}>
              <Invoices>
                <div style={{ width: '14.28%' }}>{inv?.name}</div>
                <div style={{ width: '14.28%' }}>
                  {inv?.dateStart &&
                    moment(inv?.dateStart).format('DD/MM/YY HH:mm')}
                </div>
                <div style={{ width: '14%' }}>
                  {inv?.timezone?.replace(/_/g, ' ')}
                </div>
                <div style={{ width: '12%' }}>{inv?.ticketPriceGross}</div>
                <div style={{ width: '12%' }}>{inv?.availableTickets}</div>
                <div style={{ width: '14.28%' }}>{inv?.description}</div>
                <div style={{ width: '14.28%' }}>
                  {inv?.user?.firstName} {inv?.user?.lastName}
                </div>
                <div
                  style={{
                    width: '14.28%',
                    cursor: inv?.tickets?.length > 0 ? 'pointer' : 'default',
                    color: 'blue'
                  }}
                  onClick={() => {
                    if (inv?.tickets?.length > 0) {
                      setIsTicketModalOpen(!isTicketModalOpen);
                      setSelectedWebinar(inv);
                    }
                  }}>
                  {inv?.tickets?.length}
                </div>
                <div style={{ width: '14.28%' }}>
                  <Button
                    disabled={isExpired}
                    onClick={() => {
                      setPurchaseTicketModalOpen(!isPurchaseTicketModalOpen);
                      setSelectedWebinar(inv);
                      setStep(WebinarsSteps.PURCHASE);
                    }}>
                    Purchase Ticket
                  </Button>
                </div>
              </Invoices>
            </AnimatedItem>
          );
        })
      )}

      <SidebarModal
        isOpen={isTicketModalOpen}
        setOpen={setIsTicketModalOpen}
        title={'Sold tickets'}
        sidebarWidth={'511px'}>
        <SoldTickets
          setIsTicketModalOpen={setIsTicketModalOpen}
          tickets={selectedWebinar?.tickets}
        />
      </SidebarModal>

      <SidebarModal
        isOpen={isPurchaseTicketModalOpen}
        setOpen={setPurchaseTicketModalOpen}
        title={step === WebinarsSteps.PURCHASE ? 'Purchase tickets' : 'Success'}
        sidebarWidth={'511px'}>
        {step === WebinarsSteps.PURCHASE && (
          <AnimatedTab key={1}>
            <CreateTicket
              setStep={setStep}
              setSelectedToken={setSelectedToken}
              selectedToken={selectedToken}
              selectedWebinar={selectedWebinar}
            />
          </AnimatedTab>
        )}
        {step === WebinarsSteps.SUCCESS && (
          <AnimatedTab key={2}>
            <Success
              currency={selectedToken.token}
              selectedToken={selectedToken}
              selectedWebinar={selectedWebinar}
            />
          </AnimatedTab>
        )}
      </SidebarModal>
    </AnimatedDashboard>
  );
};
